import apiCaller from 'services/Api/ApiCaller';
import { API_URL } from 'settings';

export class NativeApiError extends Error {
  constructor(public status: number, public detail: unknown) {
    super(typeof detail === 'string' ? detail : JSON.stringify(detail));
  }
}
/** Use normal token refresh; every financial request stays on the native namespace. */
export async function nativeRequest<T>(path: string, data?: unknown, signal?: AbortSignal): Promise<T | null> {
  const [route, query] = path.split('?');
  const params = Object.fromEntries([...new URLSearchParams(query)].filter(([, value]) => value !== ''));
  const response = await apiCaller({ apiUrl: API_URL, path: route,
    method: data === undefined ? 'GET' : 'POST', data: data === undefined ? params : data, signal });
  if (response.status === 204) return null;
  if (response.status < 200 || response.status >= 300) throw new NativeApiError(response.status, response.result);
  return response.result as T;
}
